// Lightweight i18n for user-facing screens.
// Keys are English strings by default; hi/ta only add overrides.
export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "hi", label: "हिं", name: "हिन्दी" },
  { code: "ta", label: "த", name: "தமிழ்" },
  { code: "kn", label: "ಕ", name: "ಕನ್ನಡ" },
  { code: "mr", label: "म", name: "मराठी" },
  { code: "te", label: "తె", name: "తెలుగు" },
];

const dict = {
  en: {},
  hi: {
    // Header
    "Shop": "दुकान",
    "Sell with us": "हमारे साथ बेचें",
    "Sign in": "साइन इन",
    "Sign out": "साइन आउट",
    "My Orders": "मेरे ऑर्डर",
    "Vendor Dashboard": "विक्रेता डैशबोर्ड",
    "Admin Console": "एडमिन कंसोल",
    "Become a Seller": "विक्रेता बनें",
    "Made in India": "मेड इन इंडिया",
    "Search handloom, spices, pottery…": "हैंडलूम, मसाले, मिट्टी के बर्तन खोजें…",
    // Home Hero
    "Est. 2026 · Made in India": "स्था. 2026 · मेड इन इंडिया",
    "Every purchase,": "हर खरीदारी,",
    "a story": "एक कहानी",
    "from a maker.": "किसी कारीगर से।",
    "Discover handloom sarees from Varanasi, pottery from Jaipur, spices from Kerala — and hundreds of Swadeshi treasures, sold directly by the artisans who make them.":
      "वाराणसी की हथकरघा साड़ियाँ, जयपुर की पॉटरी, केरल के मसाले — और सैकड़ों स्वदेशी उत्पाद, सीधे कारीगरों से खरीदें।",
    "Explore the bazaar": "बाज़ार देखें",
    "Sell your craft": "अपना शिल्प बेचें",
    "Artisans": "कारीगर",
    "States": "राज्य",
    "Swadeshi": "स्वदेशी",
    // Home sections
    "Browse": "ब्राउज़",
    "Categories rooted in India": "भारत की श्रेणियाँ",
    "See all →": "सब देखें →",
    "Featured": "विशेष",
    "Fresh from the workshops": "कार्यशालाओं से ताज़ा",
    "Shop all →": "सब खरीदें →",
    "Meet the makers": "कारीगरों से मिलें",
    "Voices behind the craft": "शिल्प के पीछे की आवाज़ें",
    // Products page
    "Bazaar": "बाज़ार",
    "Discover Swadeshi treasures": "स्वदेशी खज़ानों की खोज करें",
    "Search products…": "उत्पाद खोजें…",
    "Try 'haldi', 'mitti ka bartan', 'wedding saree'…": "'हल्दी', 'मिट्टी का बर्तन', 'शादी की साड़ी' आज़माएँ…",
    "All": "सभी",
    "Handloom": "हथकरघा",
    "Spices": "मसाले",
    "Pottery": "मिट्टी के बर्तन",
    "Ayurveda": "आयुर्वेद",
    "Jewellery": "आभूषण",
    "Home Decor": "गृह सजावट",
    "Loading…": "लोड हो रहा है…",
    "Bazaari is searching…": "बाज़ारी खोज रहा है…",
    "No products found": "कोई उत्पाद नहीं मिला",
    "Interpreted as": "इसके रूप में समझा",
    // Cart / Checkout / Auth
    "Your cart": "आपकी कार्ट",
    "Your bazaar bag is empty": "आपकी कार्ट खाली है",
    "Discover handmade treasures from across India.": "पूरे भारत के हस्तनिर्मित खज़ाने खोजें।",
    "Start shopping": "खरीदारी शुरू करें",
    "Order summary": "ऑर्डर सारांश",
    "Subtotal": "उप-योग",
    "Shipping": "शिपिंग",
    "Free": "मुफ़्त",
    "Total": "कुल",
    "Checkout": "चेकआउट",
    "Welcome back": "पुनः स्वागत है",
    "Join the bazaar": "बाज़ार में शामिल हों",
    "Sign in to continue shopping.": "खरीदारी जारी रखने के लिए साइन इन करें।",
    "Create your account in 30 seconds.": "30 सेकंड में खाता बनाएँ।",
    "Namaste": "नमस्ते",
    "Name": "नाम",
    "Email": "ईमेल",
    "Password": "पासवर्ड",
    "I want to": "मैं चाहता/चाहती हूँ",
    "Create account": "खाता बनाएँ",
    "New here? Create an account →": "यहाँ नए? खाता बनाएँ →",
    "Already a member? Sign in →": "पहले से सदस्य? साइन इन →",
    "Please wait…": "कृपया प्रतीक्षा करें…",
    "Sell": "बेचें",
  },
  ta: {
    "Shop": "கடை",
    "Sell with us": "எங்களுடன் விற்கவும்",
    "Sign in": "உள்நுழை",
    "Sign out": "வெளியேறு",
    "My Orders": "என் ஆர்டர்கள்",
    "Vendor Dashboard": "விற்பனையாளர் டாஷ்போர்டு",
    "Admin Console": "நிர்வாக பலகை",
    "Become a Seller": "விற்பனையாளராகுங்கள்",
    "Made in India": "இந்தியாவில் தயாரிக்கப்பட்டது",
    "Search handloom, spices, pottery…": "கைத்தறி, மசாலா, மட்பாண்டங்கள் தேடு…",
    "Est. 2026 · Made in India": "நிறுவப்பட்டது 2026 · இந்தியாவில் தயார்",
    "Every purchase,": "ஒவ்வொரு வாங்குதலும்,",
    "a story": "ஒரு கதை",
    "from a maker.": "ஒரு கைவினைஞரிடமிருந்து.",
    "Discover handloom sarees from Varanasi, pottery from Jaipur, spices from Kerala — and hundreds of Swadeshi treasures, sold directly by the artisans who make them.":
      "வாரணாசி கைத்தறி புடவைகள், ஜெய்ப்பூர் மட்பாண்டங்கள், கேரள மசாலா — நேரடியாக கைவினைஞர்களிடமிருந்து நூற்றுக்கணக்கான ஸ்வதேசி பொருள்கள்.",
    "Explore the bazaar": "பஜாரை பார்வையிடு",
    "Sell your craft": "உங்கள் கைவினையை விற்கவும்",
    "Artisans": "கைவினைஞர்கள்",
    "States": "மாநிலங்கள்",
    "Swadeshi": "ஸ்வதேசி",
    "Browse": "உலாவு",
    "Categories rooted in India": "இந்தியாவின் வகைகள்",
    "See all →": "அனைத்தையும் காண்க →",
    "Featured": "சிறப்பு",
    "Fresh from the workshops": "பணிமனையிலிருந்து புதிது",
    "Shop all →": "அனைத்தையும் வாங்க →",
    "Meet the makers": "கைவினைஞர்களை சந்திக்கவும்",
    "Voices behind the craft": "கைவினைக்குப் பின்னால் உள்ள குரல்கள்",
    "Bazaar": "பஜார்",
    "Discover Swadeshi treasures": "ஸ்வதேசி பொக்கிஷங்களை கண்டறியுங்கள்",
    "Search products…": "பொருள்களை தேடுங்கள்…",
    "Try 'haldi', 'mitti ka bartan', 'wedding saree'…": "'மஞ்சள்', 'களிமண் பாத்திரம்', 'திருமண புடவை' முயற்சிக்கவும்…",
    "All": "அனைத்தும்",
    "Handloom": "கைத்தறி",
    "Spices": "மசாலா",
    "Pottery": "மட்பாண்டம்",
    "Ayurveda": "ஆயுர்வேதம்",
    "Jewellery": "நகைகள்",
    "Home Decor": "வீட்டு அலங்காரம்",
    "Loading…": "ஏற்றுகிறது…",
    "Bazaari is searching…": "பஜாரி தேடுகிறார்…",
    "No products found": "பொருள்கள் எதுவும் இல்லை",
    "Interpreted as": "இப்படி புரிந்து கொள்ளப்பட்டது",
    "Your cart": "உங்கள் கூடை",
    "Your bazaar bag is empty": "உங்கள் கூடை காலியாக உள்ளது",
    "Discover handmade treasures from across India.": "இந்தியா முழுவதிலுமிருந்து கைவினை பொக்கிஷங்களை கண்டறியுங்கள்.",
    "Start shopping": "வாங்குதலை தொடங்கு",
    "Order summary": "ஆர்டர் சுருக்கம்",
    "Subtotal": "துணை மொத்தம்",
    "Shipping": "அனுப்புகை",
    "Free": "இலவசம்",
    "Total": "மொத்தம்",
    "Checkout": "செக்-அவுட்",
    "Welcome back": "மீண்டும் வருக",
    "Join the bazaar": "பஜாரில் சேருங்கள்",
    "Sign in to continue shopping.": "வாங்குதலை தொடர உள்நுழையவும்.",
    "Create your account in 30 seconds.": "30 வினாடிகளில் கணக்கை உருவாக்கவும்.",
    "Namaste": "வணக்கம்",
    "Name": "பெயர்",
    "Email": "மின்னஞ்சல்",
    "Password": "கடவுச்சொல்",
    "I want to": "நான் விரும்புகிறேன்",
    "Create account": "கணக்கை உருவாக்கு",
    "New here? Create an account →": "புதியவரா? கணக்கை உருவாக்கு →",
    "Already a member? Sign in →": "ஏற்கனவே உறுப்பினரா? உள்நுழையவும் →",
    "Please wait…": "தயவுசெய்து காத்திருங்கள்…",
    "Sell": "விற்க",
    "Gen Z": "Gen Z",
    "Gen Alpha": "Gen Alpha",
  },
  kn: {
    "Shop": "ಅಂಗಡಿ",
    "Sell with us": "ನಮ್ಮೊಂದಿಗೆ ಮಾರಿ",
    "Sign in": "ಸೈನ್ ಇನ್",
    "Sign out": "ಸೈನ್ ಔಟ್",
    "My Orders": "ನನ್ನ ಆರ್ಡರ್‌ಗಳು",
    "Vendor Dashboard": "ಮಾರಾಟಗಾರ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    "Admin Console": "ಆಡ್ಮಿನ್ ಕನ್ಸೋಲ್",
    "Become a Seller": "ಮಾರಾಟಗಾರರಾಗಿ",
    "Made in India": "ಭಾರತದಲ್ಲಿ ತಯಾರಿಸಿದೆ",
    "Search handloom, spices, pottery…": "ಕೈಮಗ್ಗ, ಮಸಾಲೆ, ಮಡಕೆ ಹುಡುಕಿ…",
    "Est. 2026 · Made in India": "ಸ್ಥಾ. 2026 · ಭಾರತದಲ್ಲಿ ತಯಾರಿಸಿದೆ",
    "Every purchase,": "ಪ್ರತಿ ಖರೀದಿಯೂ,",
    "a story": "ಒಂದು ಕಥೆ",
    "from a maker.": "ಒಬ್ಬ ಕಲಾವಿದನಿಂದ.",
    "Discover handloom sarees from Varanasi, pottery from Jaipur, spices from Kerala — and hundreds of Swadeshi treasures, sold directly by the artisans who make them.":
      "ವಾರಾಣಸಿ ಕೈಮಗ್ಗ ಸೀರೆಗಳು, ಜೈಪುರ ಮಡಿಕೆಗಳು, ಕೇರಳದ ಮಸಾಲೆಗಳು — ನೇರವಾಗಿ ಕಲಾವಿದರಿಂದ ನೂರಾರು ಸ್ವದೇಶಿ ಸಂಪತ್ತುಗಳು.",
    "Explore the bazaar": "ಬಜಾರ್ ನೋಡಿ",
    "Sell your craft": "ನಿಮ್ಮ ಕಲೆ ಮಾರಿ",
    "Artisans": "ಕಲಾವಿದರು",
    "States": "ರಾಜ್ಯಗಳು",
    "Swadeshi": "ಸ್ವದೇಶಿ",
    "Browse": "ಬ್ರೌಸ್",
    "Categories rooted in India": "ಭಾರತದ ವರ್ಗಗಳು",
    "See all →": "ಎಲ್ಲಾ ನೋಡಿ →",
    "Featured": "ವಿಶೇಷ",
    "Fresh from the workshops": "ಕಾರ್ಯಾಗಾರಗಳಿಂದ ಹೊಸದು",
    "Shop all →": "ಎಲ್ಲಾ ಖರೀದಿಸಿ →",
    "Meet the makers": "ಕಲಾವಿದರನ್ನು ಭೇಟಿಯಾಗಿ",
    "Voices behind the craft": "ಕಲೆಯ ಹಿಂದಿನ ಧ್ವನಿಗಳು",
    "Bazaar": "ಬಜಾರ್",
    "Discover Swadeshi treasures": "ಸ್ವದೇಶಿ ಸಂಪತ್ತನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ",
    "Search products…": "ಉತ್ಪನ್ನ ಹುಡುಕಿ…",
    "Try 'haldi', 'mitti ka bartan', 'wedding saree'…": "'ಹಳದಿ', 'ಮಣ್ಣಿನ ಪಾತ್ರೆ', 'ಮದುವೆ ಸೀರೆ' ಪ್ರಯತ್ನಿಸಿ…",
    "All": "ಎಲ್ಲಾ",
    "Handloom": "ಕೈಮಗ್ಗ",
    "Spices": "ಮಸಾಲೆ",
    "Pottery": "ಮಣ್ಣಿನ ಪಾತ್ರೆ",
    "Ayurveda": "ಆಯುರ್ವೇದ",
    "Jewellery": "ಆಭರಣ",
    "Home Decor": "ಗೃಹಾಲಂಕಾರ",
    "Loading…": "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
    "Bazaari is searching…": "ಬಜಾರಿ ಹುಡುಕುತ್ತಿದ್ದಾನೆ…",
    "No products found": "ಉತ್ಪನ್ನ ಸಿಗಲಿಲ್ಲ",
    "Interpreted as": "ಇದೆಂದು ಅರ್ಥೈಸಲಾಗಿದೆ",
    "Your cart": "ನಿಮ್ಮ ಕಾರ್ಟ್",
    "Your bazaar bag is empty": "ನಿಮ್ಮ ಬಜಾರ್ ಚೀಲ ಖಾಲಿಯಾಗಿದೆ",
    "Discover handmade treasures from across India.": "ಭಾರತದಾದ್ಯಂತ ಕೈಯಿಂದ ಮಾಡಿದ ಸಂಪತ್ತನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ.",
    "Start shopping": "ಶಾಪಿಂಗ್ ಆರಂಭಿಸಿ",
    "Order summary": "ಆರ್ಡರ್ ಸಾರಾಂಶ",
    "Subtotal": "ಉಪ-ಮೊತ್ತ",
    "Shipping": "ಶಿಪ್ಪಿಂಗ್",
    "Free": "ಉಚಿತ",
    "Total": "ಒಟ್ಟು",
    "Checkout": "ಚೆಕ್‌ಔಟ್",
    "Welcome back": "ಸ್ವಾಗತ",
    "Join the bazaar": "ಬಜಾರ್‌ಗೆ ಸೇರಿ",
    "Sign in to continue shopping.": "ಶಾಪಿಂಗ್ ಮುಂದುವರೆಸಲು ಸೈನ್ ಇನ್ ಮಾಡಿ.",
    "Create your account in 30 seconds.": "30 ಸೆಕೆಂಡುಗಳಲ್ಲಿ ಖಾತೆ ರಚಿಸಿ.",
    "Namaste": "ನಮಸ್ಕಾರ",
    "Name": "ಹೆಸರು",
    "Email": "ಇಮೇಲ್",
    "Password": "ಪಾಸ್‌ವರ್ಡ್",
    "I want to": "ನಾನು ಬಯಸುತ್ತೇನೆ",
    "Create account": "ಖಾತೆ ರಚಿಸಿ",
    "New here? Create an account →": "ಹೊಸಬರೇ? ಖಾತೆ ರಚಿಸಿ →",
    "Already a member? Sign in →": "ಈಗಾಗಲೇ ಸದಸ್ಯರೇ? ಸೈನ್ ಇನ್ →",
    "Please wait…": "ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ…",
    "Sell": "ಮಾರಾಟ",
  },
  mr: {
    "Shop": "दुकान",
    "Sell with us": "आमच्यासोबत विका",
    "Sign in": "साइन इन",
    "Sign out": "साइन आउट",
    "My Orders": "माझे ऑर्डर",
    "Vendor Dashboard": "विक्रेता डॅशबोर्ड",
    "Admin Console": "अ‍ॅडमिन कन्सोल",
    "Become a Seller": "विक्रेता व्हा",
    "Made in India": "भारतात बनवलेले",
    "Search handloom, spices, pottery…": "हातमाग, मसाले, मातीची भांडी शोधा…",
    "Est. 2026 · Made in India": "स्था. 2026 · भारतात बनवलेले",
    "Every purchase,": "प्रत्येक खरेदी,",
    "a story": "एक कथा",
    "from a maker.": "एका कारागिराकडून.",
    "Discover handloom sarees from Varanasi, pottery from Jaipur, spices from Kerala — and hundreds of Swadeshi treasures, sold directly by the artisans who make them.":
      "वाराणसीच्या हातमाग साड्या, जयपूरची मातीची भांडी, केरळचे मसाले — थेट कारागिरांकडून शेकडो स्वदेशी वस्तू.",
    "Explore the bazaar": "बाजार पहा",
    "Sell your craft": "आपली कला विका",
    "Artisans": "कारागीर",
    "States": "राज्ये",
    "Swadeshi": "स्वदेशी",
    "Browse": "ब्राउझ",
    "Categories rooted in India": "भारताच्या श्रेणी",
    "See all →": "सर्व पहा →",
    "Featured": "विशेष",
    "Fresh from the workshops": "कार्यशाळांमधून ताजे",
    "Shop all →": "सर्व खरेदी करा →",
    "Meet the makers": "कारागिरांना भेटा",
    "Voices behind the craft": "कलेमागचे आवाज",
    "Bazaar": "बाजार",
    "Discover Swadeshi treasures": "स्वदेशी खजिना शोधा",
    "Search products…": "उत्पादने शोधा…",
    "Try 'haldi', 'mitti ka bartan', 'wedding saree'…": "'हळद', 'मातीचे भांडे', 'लग्नाची साडी' वापरून पहा…",
    "All": "सर्व",
    "Handloom": "हातमाग",
    "Spices": "मसाले",
    "Pottery": "मातीची भांडी",
    "Ayurveda": "आयुर्वेद",
    "Jewellery": "दागिने",
    "Home Decor": "घरसजावट",
    "Loading…": "लोड होत आहे…",
    "Bazaari is searching…": "बाजारी शोधत आहे…",
    "No products found": "उत्पादने सापडली नाहीत",
    "Interpreted as": "असे समजले",
    "Your cart": "आपली कार्ट",
    "Your bazaar bag is empty": "आपली बाजार पिशवी रिकामी आहे",
    "Discover handmade treasures from across India.": "संपूर्ण भारतातील हस्तनिर्मित खजिना शोधा.",
    "Start shopping": "खरेदी सुरू करा",
    "Order summary": "ऑर्डर सारांश",
    "Subtotal": "उप-एकूण",
    "Shipping": "शिपिंग",
    "Free": "मोफत",
    "Total": "एकूण",
    "Checkout": "चेकआउट",
    "Welcome back": "पुन्हा स्वागत",
    "Join the bazaar": "बाजारात सामील व्हा",
    "Sign in to continue shopping.": "खरेदी सुरू ठेवण्यासाठी साइन इन करा.",
    "Create your account in 30 seconds.": "30 सेकंदात खाते तयार करा.",
    "Namaste": "नमस्कार",
    "Name": "नाव",
    "Email": "ईमेल",
    "Password": "पासवर्ड",
    "I want to": "मला हवे आहे",
    "Create account": "खाते तयार करा",
    "New here? Create an account →": "नवीन आहात? खाते तयार करा →",
    "Already a member? Sign in →": "आधीच सदस्य? साइन इन →",
    "Please wait…": "कृपया प्रतीक्षा करा…",
    "Sell": "विका",
  },
  te: {
    "Shop": "షాప్",
    "Sell with us": "మాతో అమ్మండి",
    "Sign in": "సైన్ ఇన్",
    "Sign out": "సైన్ అవుట్",
    "My Orders": "నా ఆర్డర్లు",
    "Vendor Dashboard": "విక్రేత డాష్‌బోర్డ్",
    "Admin Console": "అడ్మిన్ కన్సోల్",
    "Become a Seller": "విక్రేతగా మారండి",
    "Made in India": "భారతదేశంలో తయారు",
    "Search handloom, spices, pottery…": "చేనేత, సుగంధద్రవ్యాలు, కుండలు వెతకండి…",
    "Est. 2026 · Made in India": "స్థా. 2026 · భారత్‌లో తయారు",
    "Every purchase,": "ప్రతి కొనుగోలు,",
    "a story": "ఒక కథ",
    "from a maker.": "ఒక చేతివృత్తుల నుండి.",
    "Discover handloom sarees from Varanasi, pottery from Jaipur, spices from Kerala — and hundreds of Swadeshi treasures, sold directly by the artisans who make them.":
      "వారణాసి చేనేత చీరలు, జైపూర్ కుండలు, కేరళ సుగంధద్రవ్యాలు — నేరుగా చేతివృత్తుల నుండి వందల స్వదేశీ సంపదలు.",
    "Explore the bazaar": "బజార్ చూడండి",
    "Sell your craft": "మీ కళను అమ్మండి",
    "Artisans": "కళాకారులు",
    "States": "రాష్ట్రాలు",
    "Swadeshi": "స్వదేశీ",
    "Browse": "బ్రౌజ్",
    "Categories rooted in India": "భారత వర్గాలు",
    "See all →": "అన్నీ చూడండి →",
    "Featured": "ప్రత్యేకం",
    "Fresh from the workshops": "వర్క్‌షాప్‌ల నుండి తాజా",
    "Shop all →": "అన్నీ కొనండి →",
    "Meet the makers": "కళాకారులను కలవండి",
    "Voices behind the craft": "కళ వెనుక గొంతులు",
    "Bazaar": "బజార్",
    "Discover Swadeshi treasures": "స్వదేశీ నిధులను కనుగొనండి",
    "Search products…": "ఉత్పత్తులను వెతకండి…",
    "Try 'haldi', 'mitti ka bartan', 'wedding saree'…": "'పసుపు', 'మట్టి పాత్ర', 'పెళ్లి చీర' ప్రయత్నించండి…",
    "All": "అన్నీ",
    "Handloom": "చేనేత",
    "Spices": "సుగంధద్రవ్యాలు",
    "Pottery": "కుండలు",
    "Ayurveda": "ఆయుర్వేదం",
    "Jewellery": "నగలు",
    "Home Decor": "గృహ అలంకరణ",
    "Loading…": "లోడ్ అవుతోంది…",
    "Bazaari is searching…": "బజారీ వెతుకుతున్నాడు…",
    "No products found": "ఉత్పత్తులు దొరకలేదు",
    "Interpreted as": "ఇలా అర్థం చేసుకున్నారు",
    "Your cart": "మీ కార్ట్",
    "Your bazaar bag is empty": "మీ బజార్ సంచి ఖాళీగా ఉంది",
    "Discover handmade treasures from across India.": "భారతదేశం అంతటా చేతితో తయారు చేసిన నిధులను కనుగొనండి.",
    "Start shopping": "షాపింగ్ ప్రారంభించండి",
    "Order summary": "ఆర్డర్ సారాంశం",
    "Subtotal": "ఉప-మొత్తం",
    "Shipping": "షిప్పింగ్",
    "Free": "ఉచితం",
    "Total": "మొత్తం",
    "Checkout": "చెక్అవుట్",
    "Welcome back": "మళ్ళీ స్వాగతం",
    "Join the bazaar": "బజార్‌లో చేరండి",
    "Sign in to continue shopping.": "షాపింగ్ కొనసాగించడానికి సైన్ ఇన్ చేయండి.",
    "Create your account in 30 seconds.": "30 సెకన్లలో ఖాతా సృష్టించండి.",
    "Namaste": "నమస్కారం",
    "Name": "పేరు",
    "Email": "ఇమెయిల్",
    "Password": "పాస్‌వర్డ్",
    "I want to": "నేను కోరుకుంటున్నాను",
    "Create account": "ఖాతా సృష్టించండి",
    "New here? Create an account →": "కొత్తవారా? ఖాతా సృష్టించండి →",
    "Already a member? Sign in →": "ఇప్పటికే సభ్యులా? సైన్ ఇన్ →",
    "Please wait…": "దయచేసి వేచి ఉండండి…",
    "Sell": "అమ్మండి",
  },
};

export function translate(lang, key) {
  if (!lang || lang === "en") return key;
  return dict[lang]?.[key] || key;
}
